"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ListItemSecondaryAction.default;
  }
});

var _ListItemSecondaryAction = _interopRequireDefault(require("./ListItemSecondaryAction"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/ListItemSecondaryAction/index.js
// module id = 530
// module chunks = 0